// extracted by mini-css-extract-plugin
module.exports = {"root":"Secondary_root__3ZH_1","connected":"Secondary_connected__2qClt","btn":"Secondary_btn__SFfR3"};